<div class="radar-chart">
  @if (dataset().length) {
    <highcharts-chart
      class="highcharts-light"
      [options]="chartOptions()"
    />
  } @else {
    <div class="radar-chart__no-data">No chart data available.</div>
  }
</div>
